// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { OrientationSlim, IOrientationSlim } from "./OrientationSlim.gen";

export interface IHardwareStatusSlim {
	statusTimestamp: string | undefined;

	upTime: number;

	humidity: number;

	coreUsages: number[];

	signal: number | undefined;

	orientation: IOrientationSlim | undefined;

	$type?: string | undefined;
}
export class HardwareStatusSlim {
	constructor(data?: IHardwareStatusSlim) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.statusTimestamp) { this.statusTimestamp = new Date(data.statusTimestamp); }
		if (data.orientation) { this.orientation = new OrientationSlim(data.orientation); }
	}

	statusTimestamp: Date | undefined = new Date();

	upTime: number = 0;

	humidity: number = 0;

	coreUsages: number[] = [];

	signal: number | undefined;

	orientation: OrientationSlim | undefined;

	static $type: string = "CoreApi.Controllers.HardwareStatusSlim, ";
	$type?: string | undefined = HardwareStatusSlim.$type;
}

